export const REFUND_APPROVAL_TEXT = {
  tabDetail: 'Detalle',
  tabHistory: 'Historial',
  showNextTab: 'Mostrar pestaña siguiente',
  showPreviousTab: 'Mostrar pestaña anterior',
  detailsHeading: 'Detalles de devolución:',
  productsRecord: 'Registro de productos de la devolución.',
  scanHint: 'Escanea un código o busca una línea manualmente',
  summaryTitle: 'RESUMEN DE DEVOLUCIÓN',
  progressLabel: 'Progreso de conteo',
  detailsTitle: 'DETALLES DE DEVOLUCIÓN',
  refundMotiveLabel: 'Motivo de devolución',
  openDetails: 'Abrir detalles de la devolucion',
  closeDetails: 'Cerrar detalles de la devolucion',
  productsMetricTitle: 'PRODUCTOS',
  productsMetricSubtitle: 'Progreso de líneas',
  quantityMetricTitle: 'CANTIDAD',
  quantityMetricSubtitle: 'Cantidad procesada',
  pendingMetricLabel: 'Pendientes',
  rejectedMetricLabel: 'Rechazados',
  approve: 'APROBAR',
  reject: 'RECHAZAR',
  cancel: 'CANCELAR',
  registerNcr: 'REGISTRAR NCR',
  ncrPending:
    'Esta devolución aún no tiene un NCR registrado. Registra el NCR para completar el proceso.',
  ncrDialogTitle: 'Registrar NCR',
  ncrDialogDescription:
    'Ingresa el número de NCR para esta devolución. Una vez registrado quedará reflejado en el historial.',
  ncrNumberLabel: 'Número de NCR',
  ncrNumberPlaceholder: 'Ej. NCR-123456',
  ncrSave: 'GUARDAR',
  ncrRequired: 'Ingresa el número de NCR.',
  ncrSaveError: 'No se pudo registrar el NCR. Intenta nuevamente.',
  maxCharacters: 'Cantidad máxima de caracteres',
  alreadyFinalizedError:
    'Esta devolución ya fue aprobada o rechazada desde otra sesión.\nLa información se actualizó para reflejar su estado actual.',
  actionFailedError: 'No se pudo completar la acción. Intenta nuevamente.',
  rejectLine: 'RECHAZAR LÍNEA',
  confirmApprove: 'CONFIRMAR APROBACIÓN',
  confirmApproveShort: 'CONFIRMAR',
  confirmReject: 'CONFIRMAR RECHAZO',
  rejectLineTitle: '¿Rechazar esta línea?',
  approveRefundTitle: 'Aprobar devolución',
  rejectRefundTitle: 'Rechazar devolución',
  rejectRefundNotice: 'Al confirmar el rechazo, la devolución pasará al estado "Anulado".',
  rejectReasonLabel: 'Motivo de rechazo',
  rejectReasonPlaceholder: 'Describe el motivo del rechazo (opcional)',
  refundLabel: 'Devolución:',
  clientLabel: 'Cliente:',
  productsLabel: 'Productos:',
  copyTableAria: 'Copiar tabla de productos',
  downloadTableAria: 'Descargar tabla de productos',
  downloadCsv: 'Reporte de devolución (.csv)',
  downloadPdf: 'Reporte de devolución (.pdf)',
  scan: 'ESCANEAR',
  editCount: 'Editar conteo',
  rejectLineTooltip: 'Rechazar línea',
  allLinesRejected: 'No hay líneas para aprobar porque todas fueron rechazadas.',
  historyTitle: 'Historial de la devolución:',
  historyChronological: 'Registro cronológico',
  historyLoading: 'Cargando historial...',
  historyLoadError: 'No se pudo cargar el historial.',
  historyFetchError: 'Error cargando historial.',
  historyColDate: 'FECHA Y HORA',
  historyColUser: 'USUARIO',
  historyColChangeType: 'TIPO DE CAMBIO',
  historyColPrevious: 'REGISTRO ANTERIOR',
  historyColNew: 'REGISTRO NUEVO',
  historyChangeType: 'Tipo de cambio',
  historyPrevious: 'Registro anterior',
  historyNew: 'Registro nuevo',
  historyRejectionReason: 'Motivo de rechazo',
  historyColRejectionReason: 'MOTIVO DE RECHAZO',
  scanModalTitle: 'Escanear devolución',
  editLineTitle: 'Editar línea',
  scanModalSubtitle: 'Escanea el código de barra o ingresa el código manualmente',
  editLineSubtitle: 'Revisa y actualiza la cantidad verificada',
  backToDetail: 'VOLVER AL DETALLE',
  saveAndContinue: 'GUARDAR Y CONTINUAR',
  updateLine: 'ACTUALIZAR LÍNEA',
  updating: 'ACTUALIZANDO...',
  savingLine: 'Guardando línea...',
  updatingLine: 'Actualizando línea...',
  productAlreadyVerified: 'Producto ya verificado',
  noLineForCode: 'No encontramos una línea para este código.',
  quantityExceedsOriginal: 'La cant. no puede ser mayor a la cant. original',
  rejectLineBodyPrefix: 'La cantidad verificada de',
  rejectLineBodySuffix:
    'se establecerá en 0 y la línea quedará marcada como rechazada. Podrás modificarla en cualquier momento.',
  attachmentsEmpty:
    'Cuando esta devolución tenga imágenes o archivos asociados, aparecerán aquí para su revisión.',
  linesVerifiedOf: 'de',
  linesVerifiedSuffix: 'líneas verificadas para aprobar',
  productFallback: 'producto',
  editCountAriaPrefix: 'Editar conteo de',
  rejectAriaPrefix: 'Rechazar',
  csvProductsInRefund: 'PRODUCTOS EN DEVOLUCIÓN',
  filenameFallback: 'devolucion',
  pdfError: 'Error al generar PDF de devolución:',
  emptyProducts: 'No hay productos en devolución.',
  defaultUnit: 'UN',
  productsHeading: 'Productos en devolución:',
  actionColumn: 'ACCIÓN',
  cardPackaging: 'EMPAQUE',
  cardMotive: 'MOTIVO',
  cardCondition: 'CONDICIÓN',
  cardOriginalQty: 'CANT. ORIGINAL',
  cardVerifiedQty: 'CANT. VERIFICADA',
  cardUnitPrice: 'PRECIO UNIT.',
  cardTotal: 'TOTAL',
  cardStatus: 'Estado:',

  cameraScanTitle: 'Escaneo con cámara',
  cameraScanSubtitle: 'Activa la cámara para leer el código de barras automaticamente',
  openCamera: 'Abrir camara',
  searchCodeLabel: 'Código de barra o código de producto',
  searchCodePlaceholder: 'Ej. 0728109293484',
  searchLine: 'Buscar línea',
  productNotFoundTitle: 'Producto no encontrado en esta devolución',
  productNotFoundHint: 'Verifica que estás escaneando el producto correcto.',
  productWillAppear: 'El producto aparecerá aquí al escanear',
  updateQuantityHintPrefix: 'Puedes actualizar la cantidad si necesitas corregir el conteo o',
  startNewScan: 'iniciar un nuevo escaneo',
  editProcessedLine: 'EDITAR LÍNEA',
  clearScannedProductAria: 'Borrar producto escaneado',
  originalQtyLabel: 'ORIG.:',
  verifiedQtyLabel: 'VERIF.:',
  verifiedQtyFieldLabel: 'Cant. verificada',
  verifiedQtyPlaceholder: 'Ej. 8',
  verifiedQtyDecimalPlaceholder: 'Ej. 1.50',
  verifiedQtyHelper: 'Ingresa las unidades reales contadas',
  packagingChoiceTitle: 'Selecciona la unidad de empaque',
  packagingChoiceSubtitle: 'Este código aparece en más de una línea. Elige el empaque que estás contando.',
  packagingChoicePackaging: 'Empaque',
  packagingChoiceMotive: 'Motivo',
  packagingChoiceOriginalQty: 'Cant. orig.',
  packagingChoiceStatus: 'Estado',
  selectPackagingAria: 'Seleccionar empaque',
  packagingChoiceConfirm: 'CONFIRMAR'
}
